<template>
  <v-app v-if="userReady">
    <v-snackbar
      v-model="snackbarVisible"
      :timeout="timeout"
      :color="SNACKBAR_CONTEXT"
      top
    >
      {{ message }}
      <v-btn text @click="snackbarVisible = false" class="float-right"
        >OK</v-btn
      >
    </v-snackbar>
    <div v-if="$keycloak.authenticated && $keycloak.profile && userReady">
      <v-content>
        <GlobalNavContainer
          :dynamicItems="isNoMenuItems"
          v-if="!isSSOWindow"
          :canClickXiftLogo="canClickXiftLogo"
        />
        <GlobalContainer :isSSOWindow="isSSOWindow" />
        <GlobalDialog v-if="showTrialWillEndAlert" />
      </v-content>
    </div>
  </v-app>
  <loader v-else></loader>
</template>
<script>
import EventBus from '@/EventBus';
import { mapState, mapMutations } from 'vuex';
import store from './store/index';
import GlobalNavContainer from '@/components/GlobalComponent/GlobalNavContainer';
import GlobalContainer from '@/components/GlobalComponent/GlobalContainer';
import GlobalDialog from '@/components/GlobalComponent/GlobalDialog';
import WSService from '@/services/WebSocketConnection';
import { setDesktopNotificationConsent } from '@/services/Notifications/NotificationConsent';
import httpCodes from './constants/httpCodes';
export default {
  // name: 'App',
  store,
  components: {
    GlobalNavContainer,
    GlobalContainer,
    GlobalDialog
  },

  data: () => ({
    ws: null,
    msg: '',
    snackbarVisible: false,
    SNACKBAR_CONTEXT: null,
    message: '',
    userReady: false,
    timeout: 4000
  }),
  methods: {
    ...mapMutations(['setAllPermissions']),
    ...mapMutations('dashboard', ['setWidgetData', 'setSelectedDashboardDate']),
    ...mapMutations('notifications', ['setNotiClientToken']),
    async initApp() {
      this.userReady = true;
      this.userData = JSON.parse(localStorage.getItem('userData'));

      EventBus.$on('ACTIVATE_SNACKBAR', snackbarData => {
        this.snackbarVisible = snackbarData.visible;
        this.message = snackbarData.message;
        this.SNACKBAR_CONTEXT =
          snackbarData.context === 'success' ? '#58E2C2' : snackbarData.context;
        this.timeout = snackbarData.timeout;
      });
    },
    async bootstrapNotifications() {
      try {
        // ask if notifications can be displayed
        setDesktopNotificationConsent();
        // create a client to get token for websocket
        //* if token not present get a new token
        if (!Object.keys(this.notifications?.objNotiToken || {}).length) {
          const objResponse = this.parseResponse(
            await this.$services.notification.createClient(
              this.userInformation?.userId
            )
          );
          if (objResponse.length) {
            // set token response in store to reuse for further page loads
            this.setNotiClientToken(objResponse[0]);
          } else {
            this.snackbar('error', 'Cannot get notifications at this time.');
          }
        }
        // once client is created or token is already there, use the token to create a websocket with that token
        // web socket will be connected irrespective of client permission of desktop
        const objWSConnector = new WSService();
        objWSConnector.initSocket(
          this.notifications?.objNotiToken?.token || ''
        );
      } catch (err) {
        this.snackbar('error', 'Cannot get notifications.');
      }
    },
    axiosRequestInterceptor(vm) {
      this.axios.interceptors.request.use(
        function(config) {
          vm.$store.commit('loading', true);
          return config;
        },
        error => {
          vm.$store.commit('loading', false);
          return Promise.reject(error);
        }
      );
    },
    axiosResponseInterceptor(vm) {
      this.axios.interceptors.response.use(
        response => {
          vm.$store.commit('loading', false);
          return response;
        },
        error => {
          /*
            401 logout
            remaining 4xx series - back one page
            5xx series - snackbar
          */
          if (error.response) {
            if (error.response.status === httpCodes.UNAUTHORIZED) {
              this.logoutUser();
            } else if (
              error.response.status >= httpCodes.FORBIDDEN &&
              error.response.status <= httpCodes.UNAVAILABLE
            ) {
              this.$rapid7.log(JSON.stringify(error));
              if (this.$route.hash) {
                this.initalRoute('GO_TO_INITAL');
              } else {
                // this.$router.go(-1);
              }
            } else if (
              error.response.status >= httpCodes.SERVER_ERROR &&
              error.response.status <= httpCodes.NETWORK_AUTH_REQUIRED
            ) {
              this.$rapid7.log(JSON.stringify(error));
              vm.snackbar('error', vm.$message.ERROR);
            }
          } else {
            // vm.snackbar('error', vm.$message.ERROR);
          }
          this.$rapid7.log(JSON.stringify(error));
          return Promise.reject(error);
        }
      );
    }
  },
  beforeMount() {
    this.setWidgetData({});
    this.setSelectedDashboardDate('');
    EventBus.$on('userMounted', () => {
      this.$nextTick(() => {
        this.initApp();
        this.bootstrapNotifications();
      });
    });
  },

  computed: {
    ...mapState(['refCount', 'notifications']),
    isSSOWindow() {
      return this.$route.meta?.type === 'sso';
    },

    // Adding a reusable flag for not showing any menu item.
    // In case of restricted routes
    isNoMenuItems() {
      return this.noMenuItems && [];
    },
    noMenuItems() {
      return this.$route.meta?.noMenuItems;
    },
    canClickXiftLogo() {
      return this.$route.meta?.canClickXiftLogo;
    },
    // To start showing trial expire alert only for private admin of subscribed org
    showTrialWillEndAlert() {
      return (
        !this.isCurrentOrgLegacy &&
        this.$can('manage', 'subscription') &&
        !this.noMenuItems
      );
    }
  },
  created() {
    let vm = this;
    this.axiosResponseInterceptor(vm);
    this.axiosRequestInterceptor(vm);
  },
  beforeDestroy() {
    EventBus.$off('userMounted');
  }
};
</script>
